export default function anonymous(it
) {
var out='<section class="related-reading" > <h4 class="reading__title">推荐阅读</h4> <div class="reading__news" id="reading-news"></div></section>';return out;
}